import { render, staticRenderFns } from "./sn-navigator.vue?vue&type=template&id=33e0a83e"
import script from "./sn-navigator.vue?vue&type=script&lang=js"
export * from "./sn-navigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports